// extracted by mini-css-extract-plugin
module.exports = {"first-step":"FirstStep_first-step__kz2Bw","first-step__boxes":"FirstStep_first-step__boxes__11bWF"};